import { ITirPmDropdownOption } from "tir-components";

/**
 * * Модель опции в дропдауне выбора приоритета
 */
export class PriorityDropdownOptionModel implements ITirPmDropdownOption {
  /**ID приоритета */
  Id!: number;
  /**Название */
  Name!: string;
  /**Цвет */
  Color!: string;

  constructor(obj?: Partial<PriorityDropdownOptionModel>) {
    Object.assign(this, obj);
  }
}
